export default function Error ({ message }: { message?: string }) {
  if (!message || message.length === 0) return null;

  return (
    <div className='error text-center text-error text-sm mb-1'>
      {message}
    </div>
  );
}
